package pnemonic.balloon_pop.drawable

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp

val Emerald: ImageVector
    get() {
        if (_Emerald != null) {
            return _Emerald!!
        }
        _Emerald = ImageVector.Builder(
            name = "Emerald",
            defaultWidth = 33.834.dp,
            defaultHeight = 33.833.dp,
            viewportWidth = 33.834f,
            viewportHeight = 33.833f
        ).apply {
            path(
                fill = SolidColor(Color(0xFF6ACC6A)),
                fillAlpha = 0.8f,
                strokeAlpha = 0.8f
            ) {
                moveTo(12.642f, 27.237f)
                lineToRelative(-6.045f, -6.045f)
                lineToRelative(0f, -8.55f)
                lineToRelative(6.045f, -6.045f)
                lineToRelative(8.549f, 0f)
                lineToRelative(6.045f, 6.045f)
                lineToRelative(0f, 8.55f)
                lineToRelative(-6.045f, 6.045f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF54CC54)),
                fillAlpha = 0.8f,
                strokeAlpha = 0.8f
            ) {
                moveTo(13.532f, 25.087f)
                lineToRelative(-4.786f, -4.786f)
                lineToRelative(0f, -6.769f)
                lineToRelative(4.786f, -4.786f)
                lineToRelative(6.769f, 0f)
                lineToRelative(4.786f, 4.786f)
                lineToRelative(0f, 6.769f)
                lineToRelative(-4.786f, 4.786f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF16AD16)),
                fillAlpha = 0.8f,
                strokeAlpha = 0.8f
            ) {
                moveTo(9.91f, 33.833f)
                lineToRelative(2.733f, -6.597f)
                lineToRelative(8.549f, 0f)
                lineToRelative(2.732f, 6.597f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF1ACC1A)),
                fillAlpha = 0.8f,
                strokeAlpha = 0.8f
            ) {
                moveTo(12.642f, 27.237f)
                lineToRelative(-6.045f, -6.045f)
                lineToRelative(-6.597f, 2.732f)
                lineToRelative(9.91f, 9.909f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF099409)),
                fillAlpha = 0.8f,
                strokeAlpha = 0.8f
            ) {
                moveTo(23.924f, 33.833f)
                lineToRelative(-2.732f, -6.597f)
                lineToRelative(6.045f, -6.045f)
                lineToRelative(6.597f, 2.732f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF16AD16)),
                fillAlpha = 0.8f,
                strokeAlpha = 0.8f
            ) {
                moveTo(27.237f, 21.192f)
                lineToRelative(0f, -8.55f)
                lineToRelative(6.597f, -2.732f)
                lineToRelative(0f, 14.014f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF47CC47)),
                fillAlpha = 0.8f,
                strokeAlpha = 0.8f
            ) {
                moveTo(6.597f, 21.192f)
                lineToRelative(0f, -8.55f)
                lineToRelative(-6.597f, -2.732f)
                lineToRelative(0f, 14.014f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF1ACC1A)),
                fillAlpha = 0.8f,
                strokeAlpha = 0.8f
            ) {
                moveTo(27.237f, 12.642f)
                lineToRelative(-6.045f, -6.045f)
                lineToRelative(2.732f, -6.597f)
                lineToRelative(9.91f, 9.909f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF47CC47)),
                fillAlpha = 0.8f,
                strokeAlpha = 0.8f
            ) {
                moveTo(12.642f, 6.597f)
                lineToRelative(-2.733f, -6.597f)
                lineToRelative(14.014f, 0f)
                lineToRelative(-2.732f, 6.597f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF60E55C)),
                fillAlpha = 0.8f,
                strokeAlpha = 0.8f
            ) {
                moveTo(6.597f, 12.642f)
                lineToRelative(6.045f, -6.045f)
                lineToRelative(-2.733f, -6.597f)
                lineToRelative(-9.91f, 9.909f)
                close()
            }
            path(
                fill = SolidColor(Color.White),
                fillAlpha = 0.8f,
                strokeAlpha = 0.8f
            ) {
                moveTo(13.23f, 6.215f)
                lineToRelative(4.372f, 0.939f)
                lineToRelative(-4.372f, 0.938f)
                lineToRelative(-0.938f, 4.372f)
                lineToRelative(-0.939f, -4.372f)
                lineToRelative(-4.372f, -0.939f)
                lineToRelative(4.372f, -0.938f)
                lineToRelative(0.938f, -4.372f)
                close()
            }
        }.build()

        return _Emerald!!
    }

@Suppress("ObjectPropertyName")
private var _Emerald: ImageVector? = null
